import styled from "styled-components";
import {Button} from "antd";

export const IconActionButton = styled(Button)`
    width: 24px;
    height: 24px;
    min-width: 24px;
    padding: 0;
    border-radius: 6px;
    background: transparent;
    border: 1px solid ${props => (props.$color ? `${props.$color}4D` : "#d9d9d9")};
    color: ${props => props.$color || "rgba(0, 0, 0, 0.65)"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;

    &:last-child {
        margin-right: 0;
    }

    .anticon {
        font-size: 12px;
        color: inherit;
    }

    &:hover,
    &:focus {
        background: ${props => (props.$color ? `${props.$color}1A` : "#fafafa")};
        border-color: ${props => (props.$color ? `${props.$color}4D` : "#40a9ff")};
        color: ${props => props.$color || "#40a9ff"};
    }

    &[disabled],
    &[disabled]:hover {
        background: transparent;
        border-color: #d9d9d9;
        color: rgba(0, 0, 0, 0.25);
    }
`;
